<router-outlet>    
    <ngx-spinner bdColor="var(--primary-color)" size="large" color="white" type="ball-scale-multiple"></ngx-spinner>
    <span style="display: none;">v1.0</span>    
</router-outlet>